<template>
  <div class="row text-start mx-0 mb-3">
    <button class="mx-0" @click="detail = false">返回</button>
  </div>
  <div class="row text-end mx-0">
    <!-- <printOutWorkOrderHistoryList /> -->
  </div>
  <div class="row mx-0">
    <workOrderHistoryList></workOrderHistoryList>
  </div>
</template>

<script>
import { inject } from "@vue/runtime-core";
import printOutWorkOrderHistoryList from "@/components/printOutWorkOrderHistoryList.vue";
import workOrderHistoryList from "@/components/workOrderHistoryList.vue";
import { provide, ref } from "vue";
export default {
  components: { printOutWorkOrderHistoryList, workOrderHistoryList },
  setup() {
    const detail = inject("detail");
    const listData = ref({});

    provide("listData", listData);

    return {
      detail,
    };
  },
};
</script>

<style scoped>
button {
  border: 0px;
  border-radius: 5px;
  background-color: var(--main-bg-color);
  color: var(--main-font-color);
  padding: 0 13px;
  width: 4.25rem;
  height: 2rem;
  line-height: 2rem;
  font-size: 1.125rem;
  font-family: dfyuanstd-w7, dfyuanstd-w5;
  text-align: center;
  margin: 0 0 0 1.5rem;
  cursor: pointer;
}
</style>
